import * as React from "react";
const SvgLeftCaret = (props) => /* @__PURE__ */ React.createElement("svg", { width: 7, height: 11, viewBox: "0 0 7 11", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M6.15237 0.956543L1.60889 5.50002L6.15237 10.0435", stroke: "currentColor" }));
export default SvgLeftCaret;
